export const borderAndBackground = (isDirty: boolean, isReadOnly: boolean, hasErrors: boolean): string => {
  switch (true) {
    case hasErrors:
      return 'border-red-100 bg-red-50';
    case isDirty:
      return 'border-yellow-100 bg-yellow-50';
    case isReadOnly:
      return 'border-coolGray-300 bg-coolGray-50';
    default:
      return 'border-coolGray-100 bg-white';
  }
};
